module.exports = __webpack_public_path__ + "static/media/alzheimers-dementia-news.53f29299.jpg";